import { LOCAL_STORAGE_KEY  } from '../constants'

const { TOKEN, ADMIN_ROLE, EMAIL_USER, TOKEN_REGISTER } = LOCAL_STORAGE_KEY;

export function setToken(token: string) {
  // console.log("local storage called ======> ", token);
  return localStorage.setItem(TOKEN, token);
}

export function setTokenRegister(token: string) {
  // console.log("local storage called ======> ", token);
  return localStorage.setItem(TOKEN_REGISTER, token);
}

export function setAdminRoles(role: any) {
  // console.log("set admin roles local storage ======> ", role);
  return localStorage.setItem(ADMIN_ROLE, role);
}

export function setEmailUser(role: any) {
  return localStorage.setItem(EMAIL_USER, role);
}

export function getToken() {
  // console.log("token from getToken ==> ", localStorage.getItem(TOKEN));
  return localStorage.getItem(TOKEN) || "";
}

export function getTokenRegister() {
  // console.log("token from getToken ==> ", localStorage.getItem(TOKEN));
  return localStorage.getItem(TOKEN_REGISTER) || "";
}

export function getAdminRoles() {
  return localStorage.getItem(ADMIN_ROLE);
}

export function geteMailUser() {
  return localStorage.getItem(EMAIL_USER) || "";
}

export function clearStorage() {
  localStorage.removeItem(TOKEN);
}